export const isLocalStorageSupported = () => {
  try {
    localStorage.setItem('_ranger-test-key', 'hi');
    localStorage.getItem('_ranger-test-key');
    localStorage.removeItem('_ranger-test-key');
    return true;
  } catch (e) {
    return false;
  }
};

export class Memory {
  constructor() {
    this.cache = {};
  }
  setItem(cacheKey, data) {
    this.cache[cacheKey] = data;
  }
  getItem(cacheKey) {
    return this.cache[cacheKey];
  }
  removeItem(cacheKey) {
    this.cache[cacheKey] = undefined;
  }
}
